import { Fragment } from 'react'
import PropTypes from 'prop-types'

import Subnav, { SubnavLink } from 'components/navigation/Subnav'
import Content from 'components/common/Content'

const SchedulesLayout = ({ hideSubnav, ...props }) => {
  return (
    <Fragment>
      {!hideSubnav && (
        <Subnav>
          <SubnavLink
            data-track-action="open-attack-schedules"
            data-track-category="sub-navigation"
            data-track-on="click"
            text="Attacks"
            to="/schedules/attacks"
          />
          <SubnavLink
            data-track-action="open-scenario-schedules"
            data-track-category="sub-navigation"
            data-track-on="click"
            text="Scenarios"
            to="/schedules/scenarios"
          />
        </Subnav>
      )}
      <Content {...props} />
    </Fragment>
  )
}

SchedulesLayout.propTypes = {
  hideSubnav: PropTypes.bool
}

export default SchedulesLayout
